import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./phoneInput.css";

export default function PhoneInputField({
  label,
  placeholder = "Введите номер телефона",
  value,
  onChange,
  error,
  defaultValue,
  disableDropdown,
  defaultCountry = "ru",
  onlyCountries = ["am", "by", "kz", "kg", "ru"],
  ...props
}) {
  const countryPrefixes = {
    am: "374",
    by: "375",
    kz: "7",
    kg: "996",
    ru: "7",
  };

  const [country, setCountry] = useState(defaultCountry);
  const [prefix, setPrefix] = useState(countryPrefixes[defaultCountry] || "7");

  useEffect(() => {
    setPrefix(countryPrefixes[defaultCountry] || "7");
  }, [defaultCountry]);

  const handleChange = (phone, countryData) => {
    console.log(phone);
    const newPrefix = countryPrefixes[countryData.countryCode] || prefix;

    if (countryData.countryCode !== country) {
      setCountry(countryData.countryCode);
      setPrefix(newPrefix);
    }

    // Если пользователь стирает код страны, возвращаем его обратно
    if (!phone.startsWith(`${newPrefix}`)) {
      phone = `+${newPrefix}`;
    }

    onChange(`+${phone}`);
  };

  return (
    <div className={`phoneInputGroup ${error ? "error" : ""}`}>
      {label && <label className="phoneInputLabel">{label}</label>}
      <PhoneInput
        disableDropdown={disableDropdown}
        onlyCountries={onlyCountries}
        country={country}
        value={value && value.startsWith(`+${prefix}`) ? value : `+${prefix}`}
        disableCountryGuess
        countryCodeEditable={false}
        jumpCursorToEnd={false}
        onChange={handleChange}
        onBlur={(e) => {
          if (!e.target.value.startsWith(`+${prefix}`)) {
            onChange(`+${prefix}`);
          }
        }}
        inputProps={{
          onKeyDown: (e) => {
            // Запрещаем удалять код страны
            if (
              (e.key === "Backspace" || e.key === "Delete") &&
              e.target.value.length <= prefix.length + 1
            ) {
              e.preventDefault();
            }
          },
        }}
        placeholder={placeholder}
        inputClass={`phoneInput ${error ? "error" : ""}`}
        containerClass={`phoneInputContainer ${error ? "error" : ""}`}
        {...props}
      />
    </div>
  );
}
